import { useQuery } from '@tanstack/react-query';

import { fetchRezeptFreeMedicalTypes } from '@/services/main/rezept';
import { useClinicContext } from './useClinicContext';
import { useTheme } from '@shared/providers/theme/ThemeContext';

/**
 * Query — 自由診療リスト dropdown data for the 編集 modal.
 * Clinic-scoped, sorted by sort_number ASC to match the Self-Pay Treatment
 * (自由診療マスタ) screen ordering (creation order, oldest → newest, with
 * manual reorders applied).
 */
export const useRezeptFreeMedicalTypes = () => {
  const { tenant, clinicNumber } = useClinicContext();
  const { serviceType } = useTheme();

  return useQuery({
    // The list is filtered by X-Service-Type; keyed by service so an A2→R2 switch
    // never shows the other service's menus from cache.
    queryKey: ['rezept-free-medical-types', tenant, clinicNumber, serviceType],
    queryFn: () => fetchRezeptFreeMedicalTypes(tenant ?? '', clinicNumber ?? ''),
    enabled: !!tenant && !!clinicNumber,
    select: data => data.data.types,
  });
};
